/*
src/utils/CallbackMakerMixin.js
wgbh-skydiagram-testing
(Originally from interactives-editor,
	dated 12 November 2018, taken from
	commit of 21 January 2019.)
astro.unl.edu
2019-06-15
*/


export function CallbackMakerMixin() {

  // This mixin adds methods for managing and making callbacks. It is
  //  essentially a primitive event dispatcher implementation.
  // Example usage:
  //  constructor() {
  //   CallbackMakerMixin.apply(this); // may also use call
  //  } 


  // Each entry in the callbacks array is an object with these
  //  properties:
  //  - type (string), unique to each entry,
  //  - funcs (array), each is unique (no redundant functions)
  this._CMM_callbacks = [];


  this.makeCallback = function(type, data) {
    // This method makes a callback to all registered functions
    //  for the given type. The optional data argument is passed
    //  to each callback function.

    let callback = this._CMM_callbacks.find(entry => entry.type === type);
    if (callback === undefined) {
      // Nothing to do -- no registered callbacks.
      return;
    }

    let funcs = callback.funcs;
    for (let i = 0; i < funcs.length; ++i) {
      try {
        funcs[i](type, this, data);
      } catch (e) {
        console.error('An exception occurred during a callback (CallbackMakerMixin). The exception follows...');
        console.error(e);
      }
    }
  };


  this.registerCallback = function(type, func) {
    // This method registers a callback function.
    // type is a string identifying the callback type (like DOM events).
    // func is the function that will be called when the callback
    //  is made. It is expected to have the following signature:
    //   func(type, caller, data),
    //  where type is the identifying string, caller is a reference to
    //  the object making the call, and data is an optional, context
    //  dependent argument that is passed to makeCallback.

    let callback = this._CMM_callbacks.find(entry => entry.type === type);
    if (callback === undefined) {
      // Need to create the initial entry object.
      this._CMM_callbacks.push({type: type, funcs: [func]});
    } else {
      let fIndex = callback.funcs.indexOf(func);
      if (fIndex === -1) {
        // Need to add the function.
        callback.funcs.push(func);
      }
			// Silently ignore attempts at redundant registrations.
    }
  };


  this.unregisterCallback = function(type, func) {
    // This method unregisters a callback function. The arguments
    //  must exactly match those used to register the function.

    let cIndex = this._CMM_callbacks.findIndex(entry => entry.type === type);
    if (cIndex === -1) {
			// The type could not be found -- silently ignore.
			return;
    }

    let funcs = this._CMM_callbacks[cIndex].funcs;
    let fIndex = funcs.indexOf(func);
    if (fIndex === -1) {
			// The function could not be found -- silently ignore.
    }

    funcs.splice(fIndex, 1);

    if (funcs.length === 0) {
      // If there are no more registered functions, delete the entry.
      this._CMM_callbacks.splice(cIndex, 1);
    }
  };

	
	this.unregisterAllCallbacks = function() {
		this._CMM_callbacks = [];
	}

  return this;
};


